import { render, staticRenderFns } from "./InformasiSistemView.vue?vue&type=template&id=0b73b514&scoped=true"
import script from "./InformasiSistemView.vue?vue&type=script&lang=js"
export * from "./InformasiSistemView.vue?vue&type=script&lang=js"
import style0 from "./InformasiSistemView.vue?vue&type=style&index=0&id=0b73b514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b73b514",
  null
  
)

export default component.exports